import { Camera, ChatAudioRecorder, ChatAudioRecorderDark, Contact, DocumentIcon, Location, VideoIcon2 } from "../../../assets/images";
import { useRecentMessage } from "../../../Slice/reduxHooks";
import { format } from 'date-fns';

export const RecentChannelLastMessage = ({ channelId }) => {
    const recentMessage = useRecentMessage(channelId);
    const { content = {}, messageType, messageTime } = recentMessage || {};
    const { message } = content || {};

    const Icon = ({ type }) => {
        switch (type) {
            case 'image' || 'camera':
                return (
                   <Camera />
                );
            case 'video':
                return (
                   <VideoIcon2 />
                );
            case 'audio':
                return (
                   <ChatAudioRecorder />
                );
            case 'file':
                return (
                   <DocumentIcon />
                );
            case 'contact':
                return(
                    <Contact />
                );
            case 'location':
                return(
                    <Location />
                );        
            default:
                return null;
        }
    };

    const renderPreview = () => {
        switch (messageType) {
            case 'text':
            case undefined:
            case null:
                return <div className="recent-message-text normal_msg">{message || ''}</div>;
            case 'image':
                return (
                    <div className="recent-message-file">
                        <Icon type={messageType} />
                        <span className="recent-file-label">{'Image'}</span>
                    </div>
                );
            case 'camera':
                return (
                    <div className="recent-message-file">
                        <Icon type={messageType} />
                        <span className="recent-file-label">{'Image'}</span>
                    </div>
                );
            case 'video':
                return (
                    <div className="recent-message-file">
                        <Icon type="video" />
                        <span className="recent-file-label">{'Video'}</span>
                    </div>
                );
            case 'audio':
                return (
                    <div className="recent-message-file">
                        <Icon type="audio" />
                        <span className="recent-file-label">{'Audio'}</span>
                    </div>
                );
            case 'file':
                return (
                    <div className="recent-message-file">
                        <Icon type="file" />
                        <span className="recent-file-label">{'File'}</span>
                    </div>
                );
            default:
                return <div className="recent-message-text">{content?.message || message || ''}</div>;
        }
    };

    return (
        <div className="recent-channel-last-message">
            {renderPreview()}
            <div className="recent-message-meta">
                {messageTime && !isNaN(messageTime) ? format(messageTime, 'h:mm a').toLowerCase(): ''}
            </div>
        </div>
    );
}